/**
 * Default (development) environment.
 * Replaced by `environment.prod.ts` in production builds via `fileReplacements`.
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://apidev.veredis.ai/api/v1/',
  viaCepBaseUrl: 'https://viacep.com.br/ws/',
  clarityProjectId: 'y5x2wagtgp',
} as const;
